import { sessionStorageUtil } from "../utils/storage";

export const getInvestorGoals = async (data) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  const { email, folioNo, pageNumber, pageSize } = data;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/investor-goals/by-folio?email=${email}&amc_code=${amcCode}&folio_no=${folioNo}&status=true&page_number=${pageNumber}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Authorization": token,
          "Content-Type": "application/json"
        },
      },
    );

    const data = await response.json();

    if ((!response.ok || data?.status !== 200) && data?.status !== 404) {
      throw new Error(data?.message || "Get Investor Goals - failed");
    }

    return {
      data: data?.data,
      error: false,
      message: data.message || "GET Investor Goals - success",
    };

  } catch (error) {
    console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
}

export const createInvestorGoal = async (data, signal) => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = sessionStorageUtil.getAccessToken();

  // const formData = new FormData();

  // formData.append("amc_code", amcCode);

  // for (const [key, value] of Object.entries(data)) {
  //   formData.append(key, value);
  // }

  // formData.forEach((value, key) => {
  //   // console.log(key, value);
  // });

  const args = {
    ...data,
    amc_code: amcCode
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/investor-goals`,
      {
        method: "POST",
        headers: {
          "Authorization": token,
          "Content-Type": "application/json"
          // "Content-Type": "application/json"
        },
        body: JSON.stringify(args),
        signal
      },
    );

    const data = await response.json();

    if ((!response.ok || data?.status !== 200) && data?.status !== 404) {
      throw new Error(data?.message || "POST Investor Goals - failed");
    }

    return {
      data: data?.data,
      error: false,
      message: data.message || "POST Investor Goals - success",
    };

  } catch (error) {
    // console.log(error);

    return {
      data: null,
      error: true,
      message: error.message,
    };
  }
}

